
import {unauthApi} from './unauth'

export const spFindBusinessNameApi = unauthApi.injectEndpoints({
  endpoints: (builder) => ({
    
    spFindBusinessName: builder.mutation({
      
      query: ({payload}) => ({
        url: '/v2/sp/FindSpByBusinessName',
        method: 'POST',
        body: payload,
      }),
    }),

  }),
  overrideExisting: false,
})

export const { useSpFindBusinessNameMutation } = spFindBusinessNameApi